import { logUsage } from 'owa-analytics';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isOcpsPolicyEnabled, OcpsPolicy } from 'owa-ocps-policy-store';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';

export function isSupportEnabled(): boolean {
    const contactSupportPolicy = isOcpsPolicyEnabled(OcpsPolicy.ContactSupport, true);
    const diagnosticsTroubleshootingtPolicy = isOcpsPolicyEnabled(
        OcpsPolicy.DiagnosticsTroubleshooting,
        true
    );

    // User-initiated UI action within the current module context
    logUsage('DiagnosticsAndSupport_IsSupportEnabled_Old', getModuleContextMailboxInfo(), {
        isSupportFlightEnabled: isGlobalFeatureEnabled('mon-diag-inappsupport'),
        isSupportPolicyEnabled: contactSupportPolicy,
        isTroubleshootingPolicyEnabled: diagnosticsTroubleshootingtPolicy,
    });
    return (
        isGlobalFeatureEnabled('mon-diag-inappsupport') &&
        (contactSupportPolicy || diagnosticsTroubleshootingtPolicy)
    );
}
